import { GET_IP, URL_CHAT_IA } from "../constants/urls.constant";
import type { ISendQuestionParam } from "./interfaces/chatbot.params";
import type { ISendQuestionResponse } from "./interfaces/chatbot.response";

const getUserIP = async (): Promise<string | null> => {
  try {
    const response = await fetch(GET_IP, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`HTTP error: ${response.status}`);
    }

    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Error obtaining IP:", error);
    return null;
  }
};

export const sendQuestion = async (
  fields: ISendQuestionParam,
  onMessage: (msg: string, success: boolean) => void
) => {
  try {
    // TODO: Acá se obtiene el token que se usará en un futuro para identificar la conversación
    // const uniqueQuestionToken = localStorage.getItem(
    //   LocalStorage.UNIQUE_QUESTION_TOKEN
    // );
    const userIp = await getUserIP();

    const body = {
      ...fields,
    };

    const response = await fetch(`${URL_CHAT_IA}/chat/create-chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(userIp && { "ip-address": userIp }),
      },
      body: JSON.stringify(body),
    });

    const json = (await response.json()) as ISendQuestionResponse;

    if (!json.success || !json.data?.stream) {
      const errorMsg = json.kindMessage || "Ha ocurrido un error inesperado.";
      onMessage(errorMsg, false);
      return;
    }

    const simulatedStream = json.data.stream;

    // TODO: Acá se guardará el token que da la respuesta para identificar la conversación
    // const uniqueQuestionToken = json.data.uniqueQuestionToken;
    // if (uniqueQuestionToken) {
    //   localStorage.setItem(
    //     LocalStorage.UNIQUE_QUESTION_TOKEN,
    //     uniqueQuestionToken
    //   );
    // }

    const words = simulatedStream.split(" ");
    let index = 0;

    const interval = setInterval(() => {
      if (index >= words.length) {
        clearInterval(interval);
        return;
      }

      const word = words[index];
      onMessage(word + " ", true);
      index++;
    }, 50);
  } catch (error) {
    console.error("Error simulating stream:", error);
    onMessage("Error de conexión. Intenta nuevamente más tarde.", false);
  }
};
